module.exports = new __parcel__URL__("8ballpool.1038ea57.png").toString();